export enum ReservationScope  {
  Dweller = 'dweller',
  Unit = 'unit',
}

export default ReservationScope;
